import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
    DashboardFilters,
    DashboardOverview,
    ChartDistribution,
    TrendData,
    ServiceStats,
    LocationStats,
    AttentionItem,
    FilterOptions
} from './dashboard-programari.interface';

@Injectable({
    providedIn: 'root'
})
export class DashboardProgramariService {
    private token!: string;
    private headers!: HttpHeaders;

    private basePath = environment.interop.basePath;
    private baseApiPath = this.basePath + 'api/programari/nomenclatoare/dashboard/';

    constructor(private http: HttpClient) { }

    private buildParams(filters: DashboardFilters): HttpParams {
        let params = new HttpParams();

        if (filters.date_from) {
            params = params.set('date_from', filters.date_from);
        }
        if (filters.date_to) {
            params = params.set('date_to', filters.date_to);
        }
        if (filters.id_modul) {
            params = params.set('id_modul', filters.id_modul.toString());
        }
        if (filters.id_locatie) {
            params = params.set('id_locatie', filters.id_locatie.toString());
        }
        if (filters.id_serviciu) {
            params = params.set('id_serviciu', filters.id_serviciu.toString());
        }

        return params;
    }

    getOverview(filters: DashboardFilters): Observable<{ success: boolean; data: DashboardOverview; filters: DashboardFilters }> {
        const params = this.buildParams(filters);
        return this.http.get<{ success: boolean; data: DashboardOverview; filters: DashboardFilters }>(
            this.baseApiPath + 'overview',
            { headers: this.headers, params }
        );
    }

    getStatusDistribution(filters: DashboardFilters): Observable<{ success: boolean; data: ChartDistribution }> {
        const params = this.buildParams(filters);
        return this.http.get<{ success: boolean; data: ChartDistribution }>(
            this.baseApiPath + 'status-distribution',
            { headers: this.headers, params }
        );
    }

    getPresenceDistribution(filters: DashboardFilters): Observable<{ success: boolean; data: ChartDistribution }> {
        const params = this.buildParams(filters);
        return this.http.get<{ success: boolean; data: ChartDistribution }>(
            this.baseApiPath + 'presence-distribution',
            { headers: this.headers, params }
        );
    }

    getByService(filters: DashboardFilters, limit: number = 10): Observable<{ success: boolean; data: ServiceStats[] }> {
        let params = this.buildParams(filters);
        params = params.set('limit', limit.toString());
        return this.http.get<{ success: boolean; data: ServiceStats[] }>(
            this.baseApiPath + 'by-service',
            { headers: this.headers, params }
        );
    }

    getByLocation(filters: DashboardFilters): Observable<{ success: boolean; data: LocationStats[] }> {
        const params = this.buildParams(filters);
        return this.http.get<{ success: boolean; data: LocationStats[] }>(
            this.baseApiPath + 'by-location',
            { headers: this.headers, params }
        );
    }

    getTrend(filters: DashboardFilters, groupBy: string = 'day'): Observable<{ success: boolean; data: TrendData; group_by: string }> {
        let params = this.buildParams(filters);
        params = params.set('group_by', groupBy);
        return this.http.get<{ success: boolean; data: TrendData; group_by: string }>(
            this.baseApiPath + 'trend',
            { headers: this.headers, params }
        );
    }

    getAttentionNeeded(filters: DashboardFilters): Observable<{ success: boolean; data: AttentionItem[] }> {
        const params = this.buildParams(filters);
        return this.http.get<{ success: boolean; data: AttentionItem[] }>(
            this.baseApiPath + 'attention-needed',
            { headers: this.headers, params }
        );
    }

    getFilterOptions(): Observable<{ success: boolean; data: FilterOptions }> {
        return this.http.get<{ success: boolean; data: FilterOptions }>(
            this.baseApiPath + 'filter-options',
            { headers: this.headers }
        );
    }

    export(filters: DashboardFilters): Observable<any> {
        const params = this.buildParams(filters);
        return this.http.get(
            this.baseApiPath + 'export',
            { headers: this.headers, params }
        );
    }

    setToken(token: string) {
        this.token = token;
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${this.token}`,
        });
    }
}
